import { ReplaySubject, Subject } from 'rxjs';

import { PauseableTimer } from './pauseable-timeout';
import {
  SlideDirection,
  Story,
  StorySlide,
  StorySlideIndexed,
} from './stories.entities';

export class StoryItem {

	private isFinished$$ = new Subject<SlideDirection>();
	// eslint-disable-next-line @typescript-eslint/member-ordering
	public isFinished$ = this.isFinished$$.asObservable();

	private slideChange$$ = new ReplaySubject<StorySlideIndexed>();
	// eslint-disable-next-line @typescript-eslint/member-ordering
	public slideChange$ = this.slideChange$$.asObservable();


	private curSlideIndex: number = 0;
	private slides: Array<StorySlideIndexed> = [];
	private playerTimeout: PauseableTimer;


	constructor(private _story: Story) {
		this.slides = (!_story.isSlidesEnabled
			? []
			: _story.slides?.map((slide: StorySlide, i: number) => ({
				...slide,
				index: i,
				story: _story,
			})))
			|| [];
	}

	public get story(): Story {
		return this._story;
	}

	public get slide(): StorySlideIndexed {
		return this.slides[this.curSlideIndex];
	}

	public next(): StoryItem {
		this.curSlideIndex++;

		return this;
	}

	public prev(): StoryItem {
		this.curSlideIndex--;

		return this;
	}

	public play(): void {
		this.resetOnFirstSlide();
		this.playCurrent();
	}

	public pause(): void {
		this.playerTimeout.pause();
	}

	public resume(): void {
		this.playerTimeout.resume();
	}

	public stop(): StoryItem {
		if (this.playerTimeout) {
			this.playerTimeout.clearTimeout();
		}

		return this;
	}

	public playCurrent(): void {
		if (this.slide) {
			this.slideChange$$.next(this.slide);
			this.playerTimeout = new PauseableTimer(() => {
				this.curSlideIndex++;
				this.playCurrent();
			}, this.slide.displayTimeSeconds * 1000);
		} else {
			this.isFinished$$.next(this.curSlideIndex < 0 ? -1 : 1);
		}
	}

	public resetOnFirstSlide(): void {
		this.curSlideIndex = 0;
		// this.slideChange$$.next(this.slides[0]);
	}

	public complete(): void {
		this.slideChange$$.complete();
		this.isFinished$$.complete();
	}


}